module.exports = __webpack_public_path__ + "files/87e0d851d4ed64a17a1b66299a9914de.png";